<ion-item class="form-element-wrapper" fill="outline" mode="md">
  <ion-textarea
    [label]="label"
    [labelPlacement]="labelPosition"
    [id]="id"
    [formControl]="formCtrl"
    [autoGrow]="autoGrow"
    [rows]="rows"
    mode="ios"
    [placeholder]="placeholder"
    (blur)="blur.emit()"
    (keydown.enter)="keydownEnter.emit($event)"
    (keyup.enter)="keyupEnter.emit($event)"
  ></ion-textarea>
  <ng-content slot="end"></ng-content>
  <mom-validation-text slot="error" [formCtrl]="formCtrl"></mom-validation-text>
  <ion-note *ngIf="helpText" slot="helper">{{ helpText }}</ion-note>
</ion-item>
